import { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { appSettingsAtom } from '../state/settings-atoms';

/** Access the resolved theme ('light' | 'dark'). Follows system preference when set to 'system'. */
export const useResolvedTheme = () => {
  const settings = useAtomValue(appSettingsAtom);
  const [resolvedTheme, setResolvedTheme] = useState<'light' | 'dark'>('light');

  useEffect(() => {
    const resolve = () => {
      const theme = settings.themeMode;
      if (theme === 'system') {
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        setResolvedTheme(systemTheme);
      } else {
        setResolvedTheme(theme);
      }
    };

    resolve();

    if (settings.themeMode === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const listener = () => resolve();
      mediaQuery.addEventListener('change', listener);
      return () => mediaQuery.removeEventListener('change', listener);
    }
  }, [settings.themeMode]);

  return resolvedTheme;
};
